/**
 *
 * @param {*} max
 */
export function randomIndex(max) {
  return Math.floor(Math.random() * max)
}
